import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
// import mutations from './mutations'

Vue.use(Vuex)

const state = {
    page: {
        global: {},
        scenes: {
            layers: []
        }
    }
}

function walkNode(node = {}, cb) {
    const { children } = node
    cb(node)
    if (!children || !children.length) return
    // eslint-disable-next-line array-callback-return
    node.children.map((item) => {
        walkNode(item, cb)
    })
}

const getters = {
    // eslint-disable-next-line no-shadow
    global: state => state.page.global,
    // eslint-disable-next-line no-shadow
    allLayers: (state) => {
    // eslint-disable-next-line prefer-const
        let flatenList = {}
        // eslint-disable-next-line no-return-assign
        const addToList = item => (flatenList[item.id] = item)
        // eslint-disable-next-line array-callback-return
        state.page.scenes.layers.map((layer) => {
            walkNode(layer, addToList)
        })
        return flatenList
    }
}

export const store = new Vuex.Store({
    state,
    getters,
    actions
//   mutations
})
// eslint-disable-next-line no-return-assign
export const initPageData = res => (store.state.page = res)
export default store
